export default __webpack_public_path__ + "static/Video_blog-3d43ad2d84ea328998da58bf19db37ee.mp4";